import { Component, OnInit, Inject } from '@angular/core';
import { Travel } from 'src/app/models/travel';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material';
import { TravelService } from '../../services/travel/travel.service';
import { DatePipe } from '@angular/common';
import { AddressService } from 'src/app/modules/shared/services/address/address.service';
import { TravelBookingAddComponent } from '../travel-booking-add/travel-booking-add.component';
import { TravelBookingViewComponent } from '../travel-booking-view/travel-booking-view.component';
import { Observable } from 'rxjs';
import { TRANSPORTATION, SPECIAL_TRANSPORTATION } from 'src/app/modules/shared/common/api';
import { startWith, map } from 'rxjs/operators';
import { LookUpLocationComponent } from 'src/app/modules/shared/components/look-up-location/look-up-location.component';
import { NotifyboxComponent } from 'src/app/modules/shared/components/notifybox/notifybox.component';
import { ConfirmationMessageComponent } from 'src/app/modules/shared/components/confirmation-message/confirmation-message.component';

@Component({
  selector: 'app-travel-summary-view',
  templateUrl: './travel-summary-view.component.html',
  styleUrls: ['./travel-summary-view.component.scss']
})
export class TravelSummaryViewComponent implements OnInit {

  travel: Travel;
  formGroup: FormGroup;
  loading:boolean = false;
  successMessage: String = '';
  bookingmsg = "";
  index = 0;
  total = 0;
  mealTotal = 0;
  mode:any;
  isCountry: boolean = false;
  isDestinationCountry: boolean = false;
  isDisabled: boolean = false;
  temporaryValue = {};
  booklist: string[]=[];
  transportationOption = TRANSPORTATION;
  specialModeOfTransportation = SPECIAL_TRANSPORTATION;

  err_handle_msg_org_cty = 'The country field is required.';
  err_handle_msg_dst_cty = 'The country field is required.';

  err_handle_msg_org_dstn = 'The province field is required.';
  err_handle_msg_prov_dstn = 'The province field is required.';

  err_handle_msg = 'The city field is required.';
  err_handle_msg_dstn = 'The city field is required.';

  err_handle_msg_org_brgy = 'The barangay field is required.';
  err_handle_msg_dstn_brgy = 'The barangay field is required.';

  dialogConfig:any;
  summaryDetail:any;
  msg:any;
  isDraft:boolean;
  isBookrequired:boolean = false;
  pipe = new DatePipe('en-US');
  mealOption = ["Breakfast","Lunch","Dinner"];
  isBook:boolean = false;
  isModePlaneOrFerry:boolean = false;
  hasDuplicate:boolean = false;

  updatedOriginCountry:any;
  updatedDestinationCountry:any;
  updatedOriginCity:any;
  updatedDestinationCity:any;
  updatedOriginBrgy:any;
  updatedDestinationBrgy:any;

  option =  {
    btnOk:'Yes',
    btnCancel: 'Cancel',
  }
  
  province = JSON.parse(localStorage.getItem('province'));
  city = [];
  barangay = [];
  cityList = {
    origin:JSON.parse(localStorage.getItem('citylist')),
    destination:JSON.parse(localStorage.getItem('citylist'))
  };
  barangayList = {
    origin:[],
    destination:[]
  };

  autosuggest = {
    'origin_barangay': '',
    'destination_barangay':'',
    'origin_country': null,
    'destination_country': null,
    'origin_city_municipality': null,
    'destination_city_municipality':null,
  };

  country = JSON.parse(localStorage.getItem('country'));
  filterCountry: Observable<string[]>;
  filterDestinationCountry: Observable<string[]>;
  filterProvince: Observable<string[]>;
  filterDestinationProvince: Observable<string[]>;
  filtercityOrigin:Observable<string[]>;
  filtercityDestination:Observable<string[]>;
  filterBarangayOrigin:Observable<string[]>;
  filterBarangayDestination:Observable<string[]>;

  constructor(
    public dialogRef: MatDialogRef<TravelSummaryViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public travelService: TravelService,
    private formBuilder: FormBuilder,
    public addressService: AddressService,
    public dialog: MatDialog
  ) { 

  }

  ngOnInit() {
    this.travel = new Travel('');
    this.formGroup = this.formBuilder.group({
      mode_of_transportation: ['',null],
      transportation_cost : ['',null],
      origin_country:['',null],
      destination_country: ['',null],
      origin_city_municipality: ['',null],
      origin_barangay: ['',null],
      destination_city_municipality: ['',null],
      destination_barangay: ['',null],
      travel_itinerary_bookings:['',null],
    });

    this.travel.itinerary_date = this.data.travel.itinerary_date;
    this.travel.formGroup = this.formGroup;
    this.mode = this.data.mode;
    if (this.data.travel) {
      this.travel.booking_details_list = this.data.travel.booking_details_list;
      this.travel.booking_details_temp = this.data.travel.booking_details_list;
    }

    // if (!this.data.res.origin) {
    //   this.formGroup.controls['origin'].disable();
    // }

    // if (!this.data.res.destination) {
    //   this.formGroup.controls['destination'].disable();
    // } 
    // this.formGroup.controls['travel_itinerary_bookings'].disable();

    this.formGroup.controls['origin_country'].setValue(this.data.res.origin_country);
    this.formGroup.controls['destination_country'].setValue(this.data.res.destination_country);
    this.formGroup.controls['origin_city_municipality'].setValue(this.data.res.origin_city_municipality);
    this.formGroup.controls['origin_barangay'].setValue(this.data.res.origin_barangay);
    this.formGroup.controls['destination_city_municipality'].setValue(this.data.res.destination_city_municipality);
    this.formGroup.controls['destination_barangay'].setValue(this.data.res.destination_barangay);
    this.formGroup.controls['mode_of_transportation'].setValue(this.data.res.mode_of_transportation);
    this.formGroup.controls['transportation_cost'].setValue(this.data.res.transportation_cost);
  
    if (this.data.res.travel_itinerary_bookings && this.data.res.travel_itinerary_bookings.length > 0) {
      this.travel.booking_details_temp = this.data.res.travel_itinerary_bookings;
      this.travel.booking_details_list = this.data.res.travel_itinerary_bookings;
      this.formGroup.controls['travel_itinerary_bookings'].setValue(this.data.res.travel_itinerary_bookings);
      this.formGroup.controls['travel_itinerary_bookings'].disable();

      this.data.res.travel_itinerary_bookings.forEach(element => {
          this.booklist.push(element);
      });
    }

    if (this.data.res.mode_of_transportation == "Airplane") {
      this.isBook = true;
      if (this.data.res.travel_itinerary_bookings.length == 0) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
    }

    if (this.formGroup.controls['origin_country'].value == "Philippines") {
      this.isCountry = true;
    }

    if (this.formGroup.controls['destination_country'].value == "Philippines") {
      this.isDestinationCountry = true;
    }

    if (this.formGroup.controls['mode_of_transportation'].value == "Airplane" || this.formGroup.controls['mode_of_transportation'].value == "Ferry" || this.formGroup.controls['mode_of_transportation'].value == "None") {
      this.formGroup.controls['transportation_cost'].setValue('');
      this.isModePlaneOrFerry = true;
    } else {
      this.isModePlaneOrFerry = false;
    }

    // if (this.data.res.origin) {
    //   let province = this.province.filter(option => option.provDesc.toLowerCase().includes(this.data.res.origin.toLowerCase()));
    //   this.changeCity(province[0].provCode,0,'origin');
    // }

    // if (this.data.res.destination) {
    //   let destinationProvince = this.province.filter(option => option.provDesc.toLowerCase().includes(this.data.res.destination.toLowerCase()));
    //   this.changeCity(destinationProvince[0].provCode,1,'destination');
    // }



    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.position = {
      'top': '0',
      'right': '0',
    }
    this.dialogConfig.width = '800px';
    this.dialogConfig.height = '100%';
    this.dialogConfig.disableClose = true;
    this.dialogConfig.panelClass = 'mat-dialog';

    this.total = this.data.res.total;
    this.isDraft = this.data.is_draft;
    if (!this.data.is_draft) {
      this.travel.disableForm();
    }
    this.filterCountry = this.formGroup.get('origin_country').valueChanges
    .pipe(startWith(''),map(val => this._filter(val)));

    this.filterDestinationCountry = this.formGroup.get('destination_country').valueChanges
    .pipe(startWith(''),map(val => this._filter(val)));

    this.filtercityOrigin = this.formGroup.get('origin_city_municipality').valueChanges
    .pipe(startWith(''),map(val => this._filter(val,2,'origin')));

    this.filterBarangayOrigin = this.formGroup.get('origin_barangay').valueChanges
    .pipe(startWith(''),map(val => this._filter(val,3,'origin')));

    this.filtercityDestination = this.formGroup.get('destination_city_municipality').valueChanges
    .pipe(startWith(''),map(val => this._filter(val,2,'destination')));

    this.filterBarangayDestination = this.formGroup.get('destination_barangay').valueChanges
    .pipe(startWith(''),map(val => this._filter(val,3,'destination')));

   this.autosuggest.origin_country = (this.data.res.origin_country)? this.data.res.origin_country : ' ' ;
   this.autosuggest.origin_city_municipality = (this.data.res.origin_city_municipality)? this.data.res.origin_city_municipality : ' ' ;
   this.autosuggest.origin_barangay = (this.data.res.origin_barangay)? this.data.res.origin_barangay : ' ' ;
   this.autosuggest.destination_country = (this.data.res.destination_country)? this.data.res.destination_country : ' ' ;
   this.autosuggest.destination_city_municipality = (this.data.res.destination_city_municipality)? this.data.res.destination_city_municipality : ' ' ;
   this.autosuggest.destination_barangay = (this.data.res.destination_barangay)? this.data.res.destination_barangay : ' ' ;
   
   this.formGroup.get('mode_of_transportation').valueChanges.subscribe(value => { 
    if (value == "Airplane") {
      this.isBook = true;
      this.formGroup.controls['travel_itinerary_bookings'].enable();
      this.isModePlaneOrFerry = true;
      this.isDisabled = true;

      this.booklist = [];
      this.travel.booking_details_temp = [];
      this.travel.booking_details_list = this.travel.booking_details_temp;
      this.formGroup.controls['travel_itinerary_bookings'].setValue('');
    } else if (value == "Ferry" || value == "None") {
      this.isModePlaneOrFerry = true;
      this.isDisabled = false;
      this.isBook = false;
      
      this.formGroup.controls['travel_itinerary_bookings'].disable();
      this.formGroup.controls['travel_itinerary_bookings'].setValue('');
      this.formGroup.controls['transportation_cost'].setValue('');

      this.booklist = [];
      this.travel.booking_details_temp = [];
      this.travel.booking_details_list = this.travel.booking_details_temp;
      this.formGroup.controls['travel_itinerary_bookings'].setValue('');
    } else {
      this.isBook = false;
      this.isModePlaneOrFerry = false;
      this.formGroup.controls['travel_itinerary_bookings'].setValue('');
      this.formGroup.controls['travel_itinerary_bookings'].disable();
      this.formGroup.controls['transportation_cost'].setValue('');
      this.travel.booking_details_temp = [];
      this.booklist = [];
      this.travel.booking_details_list = [];
      this.isDisabled = false;
    }
  });

  this.updatedOriginCountry = this.formGroup.controls['origin_country'].value;
  this.updatedDestinationCountry = this.formGroup.controls['destination_country'].value;
  this.updatedOriginCity = this.formGroup.controls['origin_city_municipality'].value;
  this.updatedDestinationCity = this.formGroup.controls['destination_city_municipality'].value;

  if (this.formGroup.controls['origin_country'].value == "Philippines") {
    const validateOriginCity = this.cityList['origin'].filter(option => option.title.toLowerCase() === this.updatedOriginCity.toLowerCase());
    this.changeBarangay(validateOriginCity[0].citymunCode,0,'origin');
  }

  if (this.formGroup.controls['destination_country'].value == "Philippines") {
    const validateDestinationCity = this.cityList['destination'].filter(option => option.title.toLowerCase() === this.updatedDestinationCity.toLowerCase());
    this.changeBarangay(validateDestinationCity[0].citymunCode,0,'destination');
  }

  this.formGroup.get('origin_country').valueChanges.subscribe(value => {
    this.changeCountry(value,'origin_country');
    this.updatedOriginCountry = value;
  });

  this.formGroup.get('destination_country').valueChanges.subscribe(value => {
    this.changeDestinationCountry(value,'destination_country')
    this.updatedDestinationCountry = value;
  });

  this.formGroup.get('origin_city_municipality').valueChanges.subscribe(value => {
    this.updatedOriginCity = value;
    if (this.formGroup.value.origin_city_municipality != value) {
      this.formGroup.controls['origin_barangay'].setValue('');
    }
  });

  this.formGroup.get('destination_city_municipality').valueChanges.subscribe(value => {
    this.updatedDestinationCity = value;
    if (this.formGroup.value.destination_city_municipality != value) {
      this.formGroup.controls['destination_barangay'].setValue('');
    }
  });

  }

  mealvalue(e) {

    if (e.checked) {
      this.mealTotal = this.mealTotal + 100;
      this.total += 100; 
    } else {
      this.total -= 100;
      this.mealTotal -= 100; 
    }

    this.formGroup.controls['meal'].setValue(this.mealTotal);

  }
 
  closeOnClick() {
    this.travel.booking_details_temp = [];
    this.travel.booking_details_list = [];
    this.formGroup.controls['travel_itinerary_bookings'].setValue('');
    if (this.hasDuplicate) {
      let itineraryDate = this.travel.itinerary_date;
      let originalList = this.data.travel.itineraries.filter(function (el) {
        return el.itinerary_date == itineraryDate;
      });

      this.dialogRef.close(originalList[0].travel_itinerary_details);
    } else {
      this.dialogRef.close('');
    }
  }

  keypressValidateNumber(e,max) {
    const pattern = new RegExp(/^\d*\.?\d{0,2}$/g); // '\d'
    return pattern.test(e.key);
  }

  /**
   * Number validation on input fields
   */  
  keypressValidateNumberDecimal(e) {
    const pattern = new RegExp(/^\d*\.?\d{0,2}$/g);
    const rgx = /^[0-9]*\.?[0-9]*$/;
    if ((e.key == '.' && e.target.value.includes('.')) || !pattern.test(e.key)) {
      return false;
    }
    return (e.target.value.match(rgx)) ? true : false;
  }

  save(){
    this.loading = true;
    Object.keys(this.formGroup.controls).forEach(key => {
      let arr = ['origin_barangay','destination_barangay'];
      if (!this.formGroup.controls[key].disabled) {
        if (this.isDestinationCountry && key == 'destination_city_municipality') {
          return true;
        }

        if (this.isCountry && key == 'origin_city_municipality') {
          return true;
        }

        if (this.autosuggest[key] == null  && 
          !(key == 'mode_of_transportation') && 
          !(key == 'transportation_cost') ) {
            if (!(key == 'origin_country') && !(key == 'destination_country') && !(key == 'origin_barangay') && !(key == 'transportation_cost') && !(key == 'destination_barangay') && !(key == 'travel_itinerary_bookings')) {
              this.formKey(key);
            }
        }

        if (key == 'travel_itinerary_bookings' && this.formGroup.controls[key].value == '' && this.formGroup.controls['mode_of_transportation'].value == "Airplane") {
          this.formKey(key);
          this.isBookrequired = true;
          return true;
        }

        if (this.formGroup.controls[key].value == '' && !arr.includes(key)) {
          if (!(key == 'origin_barangay') && !(key == 'transportation_cost') && !(key == 'destination_barangay') && !(key == 'travel_itinerary_bookings')) {
            this.formKey(key);
          }
        }
      }
    });

    const validateOriginCountry = this.country.filter(option => option.toLowerCase() === this.updatedOriginCountry.toLowerCase()).length;
    const validateDestinationCountry = this.country.filter(option => option.toLowerCase() === this.updatedDestinationCountry.toLowerCase()).length;

    if (this.formGroup.controls['origin_country'].value != '' && validateOriginCountry == 0) {
      this.err_handle_msg_org_cty = 'The value indicated is not found on the list.';
      this.formKey('origin_country');
    }

    if (this.formGroup.controls['destination_country'].value != '' && validateDestinationCountry == 0) {
      this.err_handle_msg_dst_cty = 'The value indicated is not found on the list.';
      this.formKey('destination_country');
    }

    if (this.isCountry) {
      const validateOriginCity = this.cityList['origin'].filter(option => option.title.toLowerCase() === this.updatedOriginCity.toLowerCase()).length;

      if (this.formGroup.controls['origin_city_municipality'].value != '' && (validateOriginCity == 0 || validateOriginCity == undefined)) {
        this.err_handle_msg = 'The value indicated is not found on the list.';
        this.formKey('origin_city_municipality');
      }

      if (this.formGroup.controls['origin_city_municipality'].value == '') {
        this.err_handle_msg = 'The city field is required.';
        this.formKey('origin_city_municipality');
      }

      if (this.formGroup.controls['origin_barangay'].value != '' && this.formGroup.controls['origin_barangay'].value != null) {
        const validateOriginBarangay = this.barangayList['origin'].filter(option => option.brgyDesc.toLowerCase() === this.formGroup.controls['origin_barangay'].value.toLowerCase()).length;
        this.err_handle_msg_org_brgy = 'The value indicated is not found on the list.';
        if (validateOriginBarangay == 0) {
          this.formKey('origin_barangay');
        }
      }
    } else {
      if (this.formGroup.controls['origin_city_municipality'].value == '') {
        this.formKey('origin_city_municipality');
      }
    }

    if (this.isDestinationCountry) {
      const validateDestinationCity = this.cityList['destination'].filter(option => option.title.toLowerCase() === this.updatedDestinationCity.toLowerCase()).length;

      if (this.formGroup.controls['destination_city_municipality'].value != '' && (validateDestinationCity == 0 || validateDestinationCity == undefined)) {
        this.err_handle_msg_dstn = 'The value indicated is not found on the list.';
        this.formKey('destination_city_municipality');
      }

      if (this.formGroup.controls['destination_city_municipality'].value == '') {
        this.err_handle_msg_dstn = 'The city field is required.';
        this.formKey('destination_city_municipality');
      }

      if (this.formGroup.controls['destination_barangay'].value != '' && this.formGroup.controls['destination_barangay'].value != null) {
        const validatDstnBarangay = this.barangayList['destination'].filter(option => option.brgyDesc.toLowerCase() === this.formGroup.controls['destination_barangay'].value.toLowerCase()).length;
        this.err_handle_msg_dstn_brgy = 'The value indicated is not found on the list.';
        if (validatDstnBarangay == 0) {
          this.formKey('destination_barangay');
        }
      }
    } else {
      if (this.formGroup.controls['destination_city_municipality'].value == '') {
        this.formKey('destination_city_municipality');
      }
    }

    if (!(this.specialModeOfTransportation.includes(this.formGroup.controls['mode_of_transportation'].value)) && this.formGroup.controls['transportation_cost'].value === '') {
      console.log(this.formGroup.controls['transportation_cost'].value)
      this.formKey('transportation_cost');
    }

    if (!this.formGroup.invalid) {
      let hasDupsObjects = function(array) {

          return array.map(function(value) {

            let origin_country = (value.origin_country) ? value.origin_country : "";
            let origin_city_municipality = (value.origin_city_municipality) ? value.origin_city_municipality : "";
            let origin_barangay = (value.origin_barangay ) ? value.origin_barangay : "";
            let destination_country = (value.destination_country) ? value.destination_country : "";
            let destination_city_municipality = (value.destination_city_municipality) ? value.destination_city_municipality : "";
            let destination_barangay = (value.destination_barangay) ? value.destination_barangay : "";

            return origin_country + origin_city_municipality + origin_barangay + destination_country + destination_city_municipality + destination_barangay

          }).some(function(value, index, array) { 
            return array.indexOf(value) !== array.lastIndexOf(value);
          })
      };

      let updated_list = this.data.travel.summary_list;

      updated_list[this.data.index].mode_of_transportation = this.formGroup.controls['mode_of_transportation'].value;
      updated_list[this.data.index].transportation_cost = this.formGroup.controls['transportation_cost'].value;
      updated_list[this.data.index].origin_country = this.formGroup.controls['origin_country'].value;
      updated_list[this.data.index].origin_city_municipality = this.formGroup.controls['origin_city_municipality'].value;
      updated_list[this.data.index].origin_barangay = this.formGroup.controls['origin_barangay'].value;
      updated_list[this.data.index].destination_country = this.formGroup.controls['destination_country'].value;
      updated_list[this.data.index].destination_city_municipality = this.formGroup.controls['destination_city_municipality'].value;
      updated_list[this.data.index].destination_barangay = this.formGroup.controls['destination_barangay'].value;
      updated_list[this.data.index].travel_itinerary_bookings = this.travel.booking_details_list;

      let hasDuplicate = hasDupsObjects(updated_list);

      if (hasDuplicate) {
        this.hasDuplicate = true;
        this.dialog.open(NotifyboxComponent, {
          disableClose:true,
          data: {
            reload:false,
            label:'Ok',
            isclose:true,
            message: 'Transportation details should be unique.'
          }
        }).afterClosed().subscribe(result => {
          this.travel._errors = {};
        });
      } else {
        this.data.list[this.data.index].mode_of_transportation = this.formGroup.controls['mode_of_transportation'].value;
        this.data.list[this.data.index].transportation_cost = this.formGroup.controls['transportation_cost'].value;
        this.data.list[this.data.index].origin_country = this.formGroup.controls['origin_country'].value;
        this.data.list[this.data.index].origin_city_municipality = this.formGroup.controls['origin_city_municipality'].value;
        this.data.list[this.data.index].origin_barangay = this.formGroup.controls['origin_barangay'].value;
        this.data.list[this.data.index].destination_country = this.formGroup.controls['destination_country'].value;
        this.data.list[this.data.index].destination_city_municipality = this.formGroup.controls['destination_city_municipality'].value;
        this.data.list[this.data.index].destination_barangay = this.formGroup.controls['destination_barangay'].value;
        this.data.list[this.data.index].travel_itinerary_bookings = this.travel.booking_details_list;

        this.dialog.open(NotifyboxComponent, {
          disableClose:true,
          data: {
            reload:false,
            label:'Ok',
            isclose:true,
            message: 'Itinerary has been updated.'
          }
        }).afterClosed().subscribe(result => {
          this.travel._errors = {};
          if (result) {
            this.dialogRef.close(this.data.list);
          }
        });
      }
    }

    this.loading = false;
  }

  close() {
    this.dialogRef.close(this.data.list);
  }

  formKey(key?:string) {
    this.formGroup.controls[key].setErrors({'invalid': true});
    this.formGroup.controls[key].markAsTouched();
    this.formGroup.controls[key].markAsDirty();
  }

  Delete(){
    this.data.list.splice(this.data.index, 1);
    if (this.data.mode == 1) {
      this.loading = true;
      this.travelService.deleteSummary(this.data.detail_id).subscribe(res=>{
        this.loading = false;
        this.dialogRef.close(this.data.list);
      });
    } else {
      this.dialogRef.close(this.data.list);
    }
  }

  selectSuggest(e,control?:string,mode?:number,option?:string, isFilter = false){
    let valid = this._filter(e,mode,option);
    if (valid.length == 1 && (e.length == valid[0].length)) {
      //this.autosuggest[control] = e;
      if (mode == 0 && option == 'origin') {
        this.changeCountry(this.autosuggest[control],control);
      } else if (mode == 0 && option == 'destination') {
        this.changeDestinationCountry(this.autosuggest[control],control);
      }
    } else if (valid.length == 0) {
      this.autosuggest[control] = null;
    }

    if (isFilter) {
      this.autosuggest[control] = e;
    }

  }

  changeCity(id,i?:number,option?:string,val?:string){
    this.loading = true;
    this.addressService.getCity(id).subscribe(res=>{
      this.city = res;
      this.cityList[option] = res;
      if (option == 'origin') {
        this.formGroup.get('origin_city_municipality').valueChanges.subscribe(value => {
          this.formGroup.controls['origin_barangay'].setValue('');
        });
        this.filtercityOrigin = this.formGroup.get('origin_city_municipality').valueChanges
        .pipe(startWith(''),map(val => this._filter(val,2,option)));   
        
        setTimeout(() => {
          let city = this.cityList[option].filter(option => option.citymunDesc.toLowerCase().includes(this.data.res.origin_city_municipality.toLowerCase()));
          if (city.length > 0 ) {
            this.changeBarangay(city[0].citymunCode,1, option);
          }
        }, 500);
      } else if (option == 'destination') {
        this.formGroup.get('destination_city_municipality').valueChanges.subscribe(value => {
          this.formGroup.controls['destination_barangay'].setValue('');
        });
        this.filtercityDestination = this.formGroup.get('destination_city_municipality').valueChanges
        .pipe(startWith(''),map(val => this._filter(val,2,option)));

        setTimeout(() => {
          let city = this.cityList[option].filter(option => option.citymunDesc.toLowerCase().includes(this.data.res.destination_city_municipality.toLowerCase()));
          if (city.length > 0 ) {
            this.changeBarangay(city[0].citymunCode,1, option);
          }
        }, 500); 
      }
      this.loading = false;
    });
    this.autosuggest[option] = val;
  }

  changeBarangay(id,i?:number,option?:string){
    this.addressService.getBarangay(id).subscribe(res=>{
      this.barangay = res;
      this.barangayList[option] = res;
      if (option == 'origin') {
        this.filterBarangayOrigin = this.formGroup.get('origin_barangay').valueChanges
        .pipe(startWith(''),map(val => this._filter(val,3,option)));    
      } else {
        this.filterBarangayDestination = this.formGroup.get('destination_barangay').valueChanges
        .pipe(startWith(''),map(val => this._filter(val,3,option)));
      }
    });
  }

  displayBook(e) {

  }
 
  getProvince(){
    // this.addressService.getProvince().subscribe(res=>{
    //   this.province[0].origin = res;
    //   this.province[1].destination= res;
    // });
  }

  getCountry(){
    // this.addressService.getCountry().subscribe(res=>{
    //   this.country[0].origin_country = res;
    //   this.country[1].destination_country= res;
    // });
  }

  changeCountry(e,controlName?:string) {
    this.formGroup.controls['origin_barangay'].disable();
    if (e) {
      if (e.toLocaleLowerCase() == "philippines") {
        this.isCountry = true;
        this.formGroup.controls['origin_city_municipality'].enable();
        this.formGroup.controls['origin_barangay'].enable();
      } else {
        this.isCountry = false;
      }
      this.formGroup.controls['origin_city_municipality'].setValue('');
      this.formGroup.controls['origin_barangay'].setValue('');
      this.autosuggest['origin_city_municipality'] = null;
      this.autosuggest['origin_barangay'] = null;
  
      this.autosuggest[controlName] = e;
    }
  }

  changeDestinationCountry(e,controlName?:string) {
    this.formGroup.controls['destination_barangay'].disable(); 
    if (e) {
      if (e.toLocaleLowerCase() == "philippines") {
        this.isDestinationCountry = true;
        this.formGroup.controls['destination_city_municipality'].enable();
        this.formGroup.controls['destination_barangay'].enable(); 
      } else {
        this.isDestinationCountry = false;
      }
      this.formGroup.controls['destination_city_municipality'].setValue('');
      this.formGroup.controls['destination_barangay'].setValue('');  
      this.autosuggest['destination_city_municipality'] = null;
      this.autosuggest['destination_barangay'] = null;
      this.autosuggest[controlName] = e; 
    }
  }

 /**
   * Create Booking
   */
  createBooking(){
    this.dialogConfig.width = '100vw';
    this.dialogConfig.data = {
      mode: 0,
      travel: this.travel
    }
 
    let dialogRef = this.dialog.open(TravelBookingAddComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result != '') {
        this.booklist.push(result);
        this.travel.booking_details_temp.push(result);
        this.travel.booking_details_list = this.travel.booking_details_temp;
        this.formGroup.controls['travel_itinerary_bookings'].setValue(this.travel.booking_details_temp);
      }
    });
  }

  selectBarangay(e,controlName?:string){
    this.autosuggest[controlName] = e;
  }

    /**
   * Booking add Detail
   * mode temporary data
   * @param res 
   */
  editBooking(res,i) {
    this.dialogConfig.width = '100vw';
    this.dialogConfig.data = {
      res,
      list:this.travel.booking_details_list,
      mode: 0,
      index:i,
      is_draft:true,
      itinerary_date: this.travel.itinerary_date
    }
    let dialogRef = this.dialog.open(TravelBookingViewComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  deleteBooking(i){
    let dialogRef = this.dialog.open(ConfirmationMessageComponent, {
      disableClose:true,
      data: {
        message: "Are you sure you want to delete this booking? "
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deletebookingmsg();
      }
    });
    this.index = i;
  }
  
  deletebookingmsg() {
    const itineraryBookingId = this.travel.booking_details_list[this.index].id;
    this.travel.booking_details_list[this.index]['is_delete'] = true;
    this.travel.booking_details_temp[this.index]['is_delete'] = true;
    this.removeRow(this.index,this.travel.booking_details_temp);
    this.removeRow(this.index,this.travel.booking_details_list);
    this.booklist.splice(this.index,1);
    this.formGroup.controls['travel_itinerary_bookings'].enable();
    if (this.travel.booking_details_temp.length > 0) {
      this.formGroup.controls['travel_itinerary_bookings'].disable();
    } else {
      if (this.formGroup.controls['mode_of_transportation'].value == "Airplane") {
        this.isDisabled = true;
      }
    }
    let book = (this.travel.booking_details_temp.length > 0)? this.travel.booking_details_temp : '' ;
    this.formGroup.controls['travel_itinerary_bookings'].setValue(book);
    this.bookingmsg = "";

    this.loading = true;
    this.travelService.deleteItineraryBooking(itineraryBookingId).subscribe(res=>{
      if (res) {
        this.dialog.open(NotifyboxComponent, {
          disableClose:true,
          data: {
            reload:false,
            label:'Ok',
            isclose:true,
            message: 'Booking has been deleted.'
          }
        }).afterClosed().subscribe(result => {
          if (result) {
            //this.dialogRef.close(this.data.list);
          }
        });
        this.index = 0;
      } else {
        // console.log('Something went wrong.')
      }
      this.loading = false;
    });
  }

  closeBooking() {
    this.bookingmsg = "";
    this.index = 0;
  }


  /**
   * Remove in Object Array
   * @param index index key
   * @param data list
   */
  removeRow(index,data){
    data.splice(index, 1);
  }

  private _filter(name: string,mode = 0,option?:string): string[] {
    const filterValue = name.toLowerCase();
    if (mode == 0) {
      return this.country.filter(option => option.toLowerCase().includes(filterValue));
    } else if(mode == 2) {  
      return this.cityList[option].filter(option => option.title.toLowerCase().includes(filterValue));
    } else if(mode == 3) {  
      return this.barangayList[option].filter(option => option.brgyDesc.toLowerCase().includes(filterValue));
    } else {
      return this.province.filter(option => option.provDesc.toLowerCase().includes(filterValue));
    }
  }

  
  /**
   * 1 = country
   * 2 = province
   * 3 =  city
   * 4 = barangay
   * @param i 
   */
  locationLookUp(i?:number,formInput?:string,mode?:string){
    this.dialogConfig.autoFocus = false;
    this.dialogConfig.width = '605px';
    this.dialogConfig.data = {
        i,
        city: (this.cityList[mode])? this.cityList[mode] : null,
        barangay: (this.barangayList[mode])? this.barangayList[mode] : null
    }
    let dialogRef = this.dialog.open(LookUpLocationComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (i == 1) {
          this.formGroup.controls[formInput].setValue(result.value);
          if (mode == 'origin') {
            this.changeCountry(result.value,formInput);
          } else {
            mode = 'destination'
            this.changeDestinationCountry(result.value,formInput);
          }
        } else if (i == 2) {
          this.formGroup.controls[formInput].setValue(result.value.provDesc);
          this.changeCity(result.value.provCode,0,mode);
          this.autosuggest[mode] = result.value.provDesc;
        } else if (i == 3) {
          this.formGroup.controls[formInput].setValue(result.value.citymunDesc);
          this.changeBarangay(result.value.citymunCode,0,mode);
          this.autosuggest[mode] = result.value.citymunDesc;
        } else {
          this.formGroup.controls[formInput].setValue(result.value);
          this.autosuggest[mode] = result.value;
        }
      }
    });
  }

}
